import { render, staticRenderFns } from "./hotelContent.vue?vue&type=template&id=f2d3044e&scoped=true"
import script from "./hotelContent.vue?vue&type=script&lang=js"
export * from "./hotelContent.vue?vue&type=script&lang=js"
import style0 from "./hotelContent.vue?vue&type=style&index=0&id=f2d3044e&lang=scss&scoped=true"
import style1 from "./hotelContent.vue?vue&type=style&index=1&id=f2d3044e&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d3044e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2d3044e')) {
      api.createRecord('f2d3044e', component.options)
    } else {
      api.reload('f2d3044e', component.options)
    }
    module.hot.accept("./hotelContent.vue?vue&type=template&id=f2d3044e&scoped=true", function () {
      api.rerender('f2d3044e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Hotel/components/hotelContent.vue"
export default component.exports